(function () {'use strict';}());
angular.module("elidb").directive('tutorial', function($document,$timeout) {
    return {
      restrict: 'A',
      templateUrl: __DIR__+'/views/tutorial.html',

      link:function($scope,element,attr)
      {
        var trace = angular.trace;
        var yarr,timeout;
        $scope.steps = [{num:1,text:"Select the age range of your child.",prompt:null,classname:"showTutorialAge",selector:"form.age"},
                      {num:2,text:"Select your child's primary diagnosis.",prompt:null,classname:"showTutorialDiagnosis",selector:"form.diagnosis"},
                      {num:3,text:"Select whether you'd like to see only those providers who accept Medicaid as payment.",prompt:null,classname:"showTutorialMedicaid",selector: ".medicaid-container"},
                      {num:4,text:"Select the service(s) you're looking for to help your child.",prompt:"If you select multiples services in the same search, we'll show you only the organizations that provide all of the services you select. The more services you check, the fewer results you will see.",classname:"showTutorialServices",selector:"div.service-text-container"},
                      {num:5,text:"To start a new search, click the Clear Search button or simply check/uncheck the appropriate Service boxes.",prompt:null,classname:"showTutorialReset",selector:".bottom-content"}];

        $scope.currentStep = $scope.steps[0];
        $scope.setTutorialState(true,$scope.currentStep.classname,true);

        //$timeout(initialize,1000);

        $scope.advanceStep = function() {
          var index = $scope.steps.indexOf($scope.currentStep);
          $scope.setTutorialState(true,$scope.currentStep.classname,false);
          index ++;
          if(timeout) $timeout.cancel(timeout);
          if(yarr) yarr.disposeAll();
          if(index >= $scope.steps.length) return $scope.hideTutorial();
          $scope.currentStep = $scope.steps[index];
          $scope.setTutorialState(true,$scope.currentStep.classname,true);
          timeout = $timeout(initialize,1000);
        };

        $scope.hideTutorial = function(){
          if(yarr) yarr.disposeAll();
          $scope.setTutorialState(false,$scope.currentStep.classname,false);
          $scope.currentStep = null;
        };

        $scope.blockDismiss = function($event) {
          $event.preventDefault();
          $event.stopImmediatePropagation();
        };

        function initialize() {
          var p = element.find(".tutorial-step-prompt");
          var s = element.find(".tutorial-step-text").get(0).getBoundingClientRect();
          var t = $($scope.currentStep.selector).get(0).getBoundingClientRect();
          var ps = p.length ? p.get(0).getBoundingClientRect() : null;
          var x1 = s.x;
          var y1 = (ps || s).y + (ps || s).height + 20;
          var x2 = t.x + t.width + 20;
          var y2 = t.y + 20;
          
          if(element.css("display") === "none") return;

          if(y2 > y1) d = 'M' + (x1 - x2) + ',' + (y1-y2) + ' Q' + ((x1 - x2)/2) + ',' + (y2-y1) + ' 0,' + (y2-y1);
          else d = 'M' + (x1 - x2) + ',' + (y1-y2) + ' Q' + ((x1 - x2)/2) + ',' + (y1-y2) + ' 0,0';

          yarr = new yarrow.Yarrow();
          yarr.arrow({
            x1: x1,
            y1: y1,
            x2: x2,
            y2: y2,
            d : d,
            arrowStyles: {
              'stroke-width': 2,
              'stroke': '#ffffff'
            }
          }).render();
        }
      }  
    };
  });